import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, Observable, of} from 'rxjs';

export interface City {
  nom: string;
  code: string;
  codesPostaux: string[];
}

@Injectable({
  providedIn: 'root'
})
export class GeoService
{
  private readonly apiUrl = 'https://geo.api.gouv.fr';

  constructor(private readonly http: HttpClient) {}

  public searchCities(query: string): Observable<string[]> {
    if (!query || query.length < 2) {
      return of([]);
    }

    const url = `${this.apiUrl}/communes?nom=${encodeURIComponent(query)}&fields=nom,code,codesPostaux&boost=population&limit=5`;

    return this.http.get<City[]>(url).pipe(
      map(cities => cities.map(city => city.nom)),
      catchError(err => {
        console.error('[GeoService] Error while fetching cities', err);
        return of([]);
      })
    );
  }
}
